import axios from "axios";
import appConfig from "./AppConfig";

const axiosInstance = axios.create({
  baseURL: appConfig.baseurlAPI,
  headers: { Accept: "application/json" },
  withCredentials: false,
});

export default axiosInstance;
